import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";

var Response = function () {
  function Response(headers, statusCode, body) {
    var _this = this;

    this.statusCode = statusCode;
    this.body = body;
    this.headers = {};
    Object.keys(headers).map(function (key, index) {
      _this.headers[key.toLocaleLowerCase()] = headers[key];
    });
  }

  return Response;
}();

export default Response;